import { Injectable } from '@angular/core';
import {LocalesStoreService} from '@emm/shared/store/locales/locales.service';
import {ThemeStoreService} from '@emm/shared/store/theme/theme.service';
import {ShowTagsStoreService} from '@emm/shared/store/show-tags/show-tags.service';

@Injectable({ providedIn: 'root' })
export class SharedStoreService {

    queryLocales = this.localesStore.queries;
    queryTheme = this.themeStore.queries;
    queryShowTags = this.showTagsStore.queries;
    dispatch = { ...this.localesStore.dispatch, ...this.themeStore.dispatch, ...this.showTagsStore.dispatch };

    constructor(
        private localesStore: LocalesStoreService,
        private themeStore: ThemeStoreService,
        private showTagsStore: ShowTagsStoreService
    ) { }

}
